import { Button } from "primereact/button";
import { JobRunnerTabTypes } from "./JobRunner";

interface JobRunnerToolBoxProps {
  tabType: JobRunnerTabTypes;
  isConfigEdited: boolean;
  isCodeEdited: boolean;
  isTemplateInfoEdited: boolean;
  isCodeButtonEnabled: boolean;
  saveTaskConfig: () => void;
  saveTaskCode: () => void;
  saveTemplateInfo: () => void;
  selectedJob: any;
  setIsHistoryDialogVisible: (isHistoryDialogVisible: boolean) => void;
  setIsAssignNewCodeVisible: (isAssignNewCodeVisible: boolean) => void;
  fetchCodeFilesList: () => void;
  openTestDataDialog: () => void;
  openLogsDialog: () => void;
  openAddNewJobDialog: () => void;
  openDeleteJobDialog: () => void;
}

const JobRunnerToolBox = ({
  tabType,
  isConfigEdited,
  isCodeEdited,
  isTemplateInfoEdited,
  isCodeButtonEnabled,
  saveTaskConfig,
  saveTaskCode,
  saveTemplateInfo,
  selectedJob,
  fetchCodeFilesList,
  setIsHistoryDialogVisible,
  setIsAssignNewCodeVisible,
  openTestDataDialog,
  openLogsDialog,
  openAddNewJobDialog,
  openDeleteJobDialog
}: JobRunnerToolBoxProps) => {
  const handleopenAssignNewCodeDialog = () => {
    fetchCodeFilesList();
    setIsAssignNewCodeVisible(true);
  };
  return (
    <div className="tool-box-container">
      <div className="tool-box-top-container">
        <Button
          className="p-button-success p-button-sm"
          icon="pi pi-plus"
          tooltip="New"
          onClick={openAddNewJobDialog}
        />
        <Button
          disabled={
            tabType === JobRunnerTabTypes.CONFIG
              ? !isConfigEdited
              : tabType === JobRunnerTabTypes.CODE
              ? !isCodeEdited
              : !isTemplateInfoEdited
          }
          icon="pi pi-save"
          className="p-button-primary"
          tooltip="Save"
          onClick={() =>
            tabType === JobRunnerTabTypes.CONFIG
              ? saveTaskConfig()
              : tabType === JobRunnerTabTypes.CODE
              ? saveTaskCode()
              : saveTemplateInfo()
          }
        />
        <Button
          className="p-button-primary"
          icon={"pi pi-history"}
          tooltip="History"
          onClick={() => setIsHistoryDialogVisible(true)}
          disabled={!selectedJob}
        />
        <Button
          className="p-button-primary"
          icon={"pi pi-chart-bar"}
          tooltip="Test data"
          onClick={openTestDataDialog}
          disabled={!selectedJob}
        />
        <Button
          className="p-button-primary"
          icon="pi pi-book"
          tooltip="Logs"
          onClick={openLogsDialog}
          disabled={!selectedJob}
        />
        <Button
          className="p-button-primary"
          icon="pi pi-code"
          tooltip="Assign new code"
          onClick={handleopenAssignNewCodeDialog}
          disabled={!isCodeButtonEnabled}
        />
        <Button
          className="p-button-primary"
          icon="pi pi-trash"
          tooltip="Delete"
          onClick={openDeleteJobDialog}
          disabled={!selectedJob}
        />
      </div>
    </div>
  );
};

export default JobRunnerToolBox;
